export enum XeoFeaturePlanEnum {
  XEO_STARTER = 'xeoStarter', // COMMUNITY_1
  XEO_ESSENTIALS = 'xeoEssentials', // STRIPE_1
  XEO_PRIORITY = 'xeoPriority', // STRIPE_2
  XEO_INTEGRATOR = 'xeoIntegrator', // COMMUNITY_2
  XEO_ENTERPRISE = 'xeoEnterprise',
}
